import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from 'react-query';
import { CerebroTextButton } from '../../shared/components';
import { useApi } from '../../shared/context';
import { QueryKeys } from '../../shared/hooks';
import { DataRoomTeaser } from '../../shared/models';
import { CerebroApiEndpoints } from '../../shared/utils/api';
import { getResponseData } from '../../shared/utils/axios';

interface SendTeaserDialogProps {
	dataRoomGuid: string | undefined;
	teaser: DataRoomTeaser | null;
	close: () => void;
}

export const SendTeaserDialog: React.FC<SendTeaserDialogProps> = ({ dataRoomGuid, teaser, close }) => {
	const api = useApi();
	const snackbar = useSnackbar();
	const client = useQueryClient();

	const onSendConfirmation = () => {
		if (teaser !== null) sendTeaser(teaser);
	};

	const { mutate: sendTeaser } = useMutation<DataRoomTeaser, unknown, DataRoomTeaser>(
		teaserToSend =>
			getResponseData(
				api.post<DataRoomTeaser>(CerebroApiEndpoints.Teasers.Send(dataRoomGuid, teaserToSend.guid))
			),
		{
			onMutate: () => {
				close();
			},
			onSuccess: () => {
				client.invalidateQueries(QueryKeys.Teasers.Root(dataRoomGuid));
				snackbar.enqueueSnackbar('Teaser Sent.', { variant: 'success' });
				close();
			},
			onError: () => {
				client.invalidateQueries(QueryKeys.Teasers.Root(dataRoomGuid));
				snackbar.enqueueSnackbar('There was a problem sending the teaser.', { variant: 'error' });
			},
		}
	);

	return (
		<Dialog open={teaser !== null} onClose={close}>
			<DialogTitle>Confirm Send Teaser</DialogTitle>
			<DialogContent>
				<DialogContentText>
					Are you sure you want to {teaser?.sentOn ? 'resend' : 'send'} this teaser for {teaser?.firstName}{' '}
					{teaser?.lastName} at {teaser?.bankName}?
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<CerebroTextButton onClick={close}>No</CerebroTextButton>
				<CerebroTextButton onClick={onSendConfirmation}>Yes</CerebroTextButton>
			</DialogActions>
		</Dialog>
	);
};
